module.exports = __webpack_public_path__ + "static/media/death.37d7cc7f.png";